import { useEffect, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import RankingSection from "@/pages/home/components/RankingSection";
import HighRatedSection from "@/pages/home/components/HighRatedSection";
import GenreSection from "@/pages/home/components/GenreSection";
import ScheduleSection from "@/pages/home/components/ScheduleSection";
import EditorPicksSection from "@/pages/home/components/EditorPicksSection";
import NewReleaseSection from "@/pages/home/components/NewReleaseSection";
import FaqSection from "@/pages/home/components/FaqSection";
import NewsletterSection from "@/pages/home/components/NewsletterSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  const [query, setQuery] = useState("");
  const [genre, setGenre] = useState("全部");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero query={query} onQueryChange={setQuery} />
        <RankingSection />
        <HighRatedSection />
        <GenreSection
          query={query}
          onQueryChange={setQuery}
          genre={genre}
          onGenreChange={setGenre}
        />
        <ScheduleSection />
        <EditorPicksSection />
        <NewReleaseSection />
        <FaqSection />
        <NewsletterSection />
      </main>
      <Footer />

      {showTop && (
        <button
          type="button"
          aria-label="回到顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}